/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageContent } from '../../models/image-content';

export interface ApiMasterImageContentGetActiveGet$Params {
}

export function apiMasterImageContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ImageContent>>;
    })
  );
}

apiMasterImageContentGetActiveGet.PATH = '/api/Master/ImageContent/GetActive';
